export default {"src":"/_next/static/media/BlossmLogoSmall.81d056ae.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};